import OrderProductsBlock from './OrderProductsBlock';

export default OrderProductsBlock;
